/** [i18n key, canonical label từ API] */
export const PERIOD_LABEL_DEFS = {
  CURRENT: ['bsc.label.giaidoanhientai', 'Giai đoạn hiện tại'] as const,
  KEEP: ['bsc.label.giaidoangiulai', 'Giai đoạn giữ lại'] as const,
  DELETED: ['bsc.label.giaidoanbixoa', 'Giai đoạn bị xóa'] as const,
  ROOT: ['bsc.label.chitieugoc', 'Chỉ tiêu gốc'] as const,
  EDITTABLE: [
    ['bsc.label.giaidoanhientai', 'Giai đoạn hiện tại'],
    ['bsc.label.giaidoangiulai', 'Giai đoạn giữ lại'],
  ] as const,
};

export const CONSTANTS = {
  NGANSACH_UNIT: 'VNĐ',

  ACTION_PLAN: {
    SESSION_KEY: 'cong-viec-du-an-session',
    SESSION_KEY_QUANLY: 'quan-ly-cong-viec-du-an-session',
    HIEN_THI: {
      VIET_CU_TOI: 1,
      TONG_QUAN_VIEC_CUATOI: 3,
      TONG_QUAN_TOAN_CAY: 2,
    },
    PRIORITY_TAG_PROPS: {
      low: {
        color: '#018432',
        className: '!rounded-full !m-0 !px-3 !py-0.5 !leading-normal !border-0 !bg-[linear-gradient(90.85deg,_#87FFB3_4.27%,_#018432_99.27%)] !text-white',
        label: 'Low',
      },
      medium: {
        color: '#F5A623',
        className: '!rounded-full !m-0 !px-3 !py-0.5 !leading-normal !border-0 !bg-[linear-gradient(90.85deg,_#FFE6B3_4.27%,_#F5A623_99.27%)] !text-white',
        label: 'Medium',
      },
      high: {
        color: '#ff4d4f',
        className: '!rounded-full !m-0 !px-3 !py-0.5 !leading-normal !border-0 !bg-[linear-gradient(90.85deg,_#f9a2a2_4.27%,_#ff4d4f_99.27%)] !text-white',
        label: 'High',
      },
    },
    /** Hằng số bảng Công việc dự án (columns.tsx) */
    TABLE: {
      CSS_CLASS: {
        COL_TEXT: 'cvda-table-col-text',
        COL_SELECT_POPUP: 'cvda-table-col-select-popup',
      },
      OVERVIEW_EDITABLE_COLUMN_KEYS: [
        'tenCongViec',
        'hienThiTrangQuanLy',
        'kanBanMucDoUuTien',
        'moTa',
        'filesDinhKem',
      ],
      TANSUAT: {
        NGAY: 1,
        TUAN: 2,
        THANG: 3,
        BAO_CAO_CUOI_KY: 4,
        LABELS: {
          1: 'Ngày',
          2: 'Tuần',
          3: 'Tháng',
          4: 'Báo cáo cuối kỳ',
        } as Record<number, string>,
        OPTIONS: [
          { value: 1, label: 'Ngày' },
          { value: 2, label: 'Tuần' },
          { value: 3, label: 'Tháng' },
          { value: 4, label: 'Báo cáo cuối kỳ' },
        ],
      },
      /** 0=Hiệu suất tỉ trọng, 1=Nhập tay, 2=Tổng con, 3=Trung bình con */
      HINH_THUC_TONG_HOP: {
        HIEU_SUAT_TI_TRONG: 0,
        NHAP_TAY: 1,
        TONG_CON: 2,
        TRUNG_BINH_CON: 3,
        LABELS: {
          0: 'Hiệu suất tỉ trọng',
          1: 'Báo cáo nhập tay',
          2: 'Tổng con',
          3: 'Trung bình con',
        } as Record<number, string>,
        PARENT_OPTIONS: [
          { label: 'Hiệu suất tỉ trọng', value: 0 },
          { label: 'Tổng con', value: 2 },
          { label: 'Trung bình con', value: 3 },
        ],
        CHILD_OPTIONS: [{ label: 'Báo cáo nhập tay', value: 1 }],
      },
      PRIORITY: {
        LOW: 'LOW',
        MEDIUM: 'MEDIUM',
        HIGH: 'HIGH',
        DEFAULT: 'LOW',
        COLORS: {
          LOW: '#34c759',
          MEDIUM: '#f5a623',
          HIGH: '#ff4d4f',
        } as Record<string, string>,
        VALUES: ['LOW', 'MEDIUM', 'HIGH'] as const,
        BADGE: {
          PADDING: '1px 8px',
          BORDER_RADIUS: 999,
          FONT_SIZE: 11,
          FONT_WEIGHT: 600,
          COLOR: 'white',
        },
      },
      STATE_APPROVED: {
        PENDING: 0,
        APPROVED: 1,
        REJECTED: 2,
        LABELS: {
          0: 'Chờ xác nhận',
          1: 'Đã xác nhận',
          2: 'Từ chối',
        } as Record<number, string>,
        DEFAULT_LABEL: 'Đã duyệt',
        STATUS_COLORS: {
          0: '#f5a623',
          1: '#34c759',
          2: '#ff4d4f',
        } as Record<number, string>,
        DEFAULT_COLOR: '#34c759',
      },
      COLORS: {
        TEXT_PRIMARY: '#111',
        TEXT_MUTED: '#bbb',
        TEXT_BLACK: '#000',
        AVATAR_BG: '#fff',
        ICON_INFO: '#6B7280',
        ICON_EDIT: '#637381',
        ICON_LINK: '#1890ff',
        ICON_CHI_TIEU: '#ed7d31',
        AVATAR_EMPTY_BG: '#e5e7eb',
        AVATAR_EMPTY_COLOR: '#9ca3af',
        EMPLOYEE_OVERFLOW: '#64748b',
        EMPLOYEE_OVERFLOW_ALT: '#888',
        PLACEHOLDER_EMPLOYEE: '#ccc',
      },
      PROGRESS: {
        STROKE: '#ffab00',
        PERCENT_FONT_SIZE: 11,
        PERCENT_FONT_WEIGHT: 'bold' as const,
      },
      TEMP_ID_PREFIX: 'temp',
    },
    MINIMIZED_STORAGE_KEY: 'popup-viec-trong-ngay-minimized',
    KANBAN_SHOW_CHILDS_STORAGE_KEY: 'duancongviec-kanban-show-childs',
    RIGHT_MODE_STORAGE_KEY: 'duancongviec-left-mode',
    RIGHT_MODE_BY_TAB_KEY: {
      overview: '1',
      table: '2',
      timeline: '3',
      combine: '4',
      calendar: '5',
      kanban: '6',
    } as Record<string, string>,
    /**
     * Message SignalR / banner assign Action Plan.
     * Đổi text tại đây — i18n key dùng với t(key, default).
     */
    NOTIFY: {
      /**
       * UI thông báo assign: `'banner'` (thanh ngang cũ) | `'popover'` (icon Warning + Popover kiểu ChiTieuChildWarning).
       * Đổi biến này để test nhanh 1 trong 2.
       */
      UI_MODE: 'popover' as 'banner' | 'popover',
      RELOAD_HINT: 'Vui lòng tải lại dữ liệu nếu cần.',
      FALLBACK_TITLE: 'Có thông báo cập nhật',
      FALLBACK_BODY: 'Vui lòng tải lại dữ liệu nếu cần.',
      FALLBACK_GENERIC: 'Có thông báo mới',
      DEFAULT_DU_AN_NAME: 'Dự án',
      SCOPE_LABEL_NV: 'Nhân viên',
      SCOPE_LABEL_PB: 'Phòng ban',
      RELOAD_BTN: 'Tải lại dữ liệu',
      DISMISS_BTN: 'Đóng',
      DU_AN_MOI: {
        I18N_TITLE: 'bsc.msg.actionplan.titleduanmoi',
        I18N_BODY: 'bsc.msg.actionplan.bodyduanmoi',
        TITLE: 'Có dự án mới',
        BODY: (tenDuAn: string) =>
          `Dự án <strong>"${tenDuAn}"</strong> vừa được tạo. Vui lòng tải lại dữ liệu nếu cần.`,
      },
      DU_AN_CAP_NHAT: {
        I18N_TITLE: 'bsc.msg.actionplan.titleduancapnhat',
        I18N_BODY: 'bsc.msg.actionplan.bodyduancapnhat',
        TITLE: 'Có cập nhật dự án',
        BODY: (tenDuAn: string, scopeLabel: string) =>
          `${scopeLabel} đang được chọn vừa có dự án "${tenDuAn}" được cập nhật. Vui lòng tải lại dữ liệu nếu cần.`,
      },
      CONG_VIEC_MOI: {
        I18N_TITLE: 'bsc.msg.actionplan.titlecongviecmoi',
        I18N_BODY: 'bsc.msg.actionplan.bodycongviecmoi',
        TITLE: 'Có công việc mới',
        BODY: (tenDuAn: string) =>
          `Dự án <strong>"${tenDuAn}"</strong> có công việc mới vừa được tạo. Vui lòng tải lại dữ liệu nếu cần.`,
      },
      DOI_PHU_TRACH: {
        I18N_TITLE: 'bsc.msg.actionplan.titledoiphutrach',
        I18N_BODY: 'bsc.msg.actionplan.bodydoiphutrach',
        TITLE: 'Có thay đổi người phụ trách',
        BODY: (tenDuAn: string) =>
          `Dự án <strong>"${tenDuAn}"</strong> có công việc đổi người phụ trách. Vui lòng tải lại dữ liệu nếu cần.`,
      },
      CONG_VIEC_CAP_NHAT: {
        I18N_TITLE: 'bsc.msg.actionplan.titlecongvieccapnhat',
        I18N_BODY: 'bsc.msg.actionplan.bodycongvieccapnhat',
        TITLE: 'Có cập nhật công việc',
        BODY: (tenDuAn: string) =>
          `Dự án <strong>"${tenDuAn}"</strong> có công việc vừa được cập nhật. Vui lòng tải lại dữ liệu nếu cần.`,
      },
    },
  },
  FISHBONE: {
    UPPER_BONE: 0,
    LOWER_BONE: 1,
  },
  REPORT_STATUS: {
    ALL: 0, // Tất cả
    UN_REPORT: 1, // Chưa báo cáo
    REPORTED: 2, // Đã báo cáo
    PENDING_APPROVAL: 3, // Chờ duyệt
  },
  REPORT_TINH_TRANG_DUYET: {
    CHO_DUYET: 0,
    DA_DUYET: 1,
    TU_CHOI: 2,
  },
  PHAN_HE: {
    BSC: 'bsc',
    VAN_HOA: 'vanhoa',
    QUY_TRINH: 'quytrinh',
  },  
  HINH_THUC_TINH: {
    TONG: 1,
    TRUNG_BINH: 2,
    TIEN_DO: 3,
    TI_LE: 4
  },
};
